import { useEffect, useState } from 'react';

/**
 * Tracks `prefers-reduced-motion`. Framer Motion components already respect
 * it via the app-wide `MotionConfig` (see `app/providers.tsx`), but
 * non-Framer visuals — Recharts' internal SVG animations, custom count-up
 * numbers — need to check it directly.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(
    () =>
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const listener = (event: MediaQueryListEvent) => setReduced(event.matches);
    mediaQuery.addEventListener('change', listener);
    return () => mediaQuery.removeEventListener('change', listener);
  }, []);

  return reduced;
}
